export interface AppItem {
  id: string;
  title: string;
  subdomain: string;
  url: string;
  description: string;
  category: 'Pet & Health' | 'Hardware & Labs' | 'AI & Lifestyle' | 'Tools & Utilities';
  icon: 'dog' | 'cpu' | 'shirt' | 'sparkles' | 'database' | 'box' | 'printer' | 'paintbrush' | 'wrench' | 'package';
  badge: string;
  accent: 'emerald' | 'cyan' | 'purple' | 'amber' | 'blue' | 'rose' | 'indigo';
  tags: string[];
}

export const APPS: AppItem[] = [
  {
    id: 'inventory',
    title: 'MakerStock AI - Lab & Dev Board Inventory',
    subdomain: 'inventory.tiger-home.com',
    url: 'https://inventory.tiger-home.com/',
    description: 'Manage microcontrollers, dev boards, sensors, motors, IC bins, test equipment, and AI-generated pinout & hardware wikis.',
    category: 'Hardware & Labs',
    icon: 'cpu',
    badge: 'Electronics Lab',
    accent: 'cyan',
    tags: ['ESP32', 'Sensors', 'Dev Boards', 'Maker Stock'],
  },
  {
    id: 'makertools',
    title: 'MakerTools AI - Digital Fabrication Inventory',
    subdomain: 'makertools.tiger-home.com',
    url: 'https://makertools.tiger-home.com/',
    description: 'Manage 3D & SLA resin printers, CNC routers, laser cutters, Cricut plotters, 2D printers, nozzles, CNC bits, and machine tooling.',
    category: 'Hardware & Labs',
    icon: 'printer',
    badge: 'Digital Fab',
    accent: 'amber',
    tags: ['3D Printing', 'CNC & Laser', 'Cricut', 'Machine Tooling'],
  },
  {
    id: 'hobbytools',
    title: 'HobbyTools AI - Scale Modeling & Precision Tools',
    subdomain: 'hobbytools.tiger-home.com',
    url: 'https://hobbytools.tiger-home.com/',
    description: 'Track precision scale modeling tools (DSPIAE nippers, scribers, sanding), airbrushes, soldering stations, Dremel rotary tools, and detailing bits.',
    category: 'Hardware & Labs',
    icon: 'paintbrush',
    badge: 'Precision Tools',
    accent: 'rose',
    tags: ['DSPIAE', 'Airbrush', 'Soldering', 'Scale Modeling'],
  },
  {
    id: 'handtools',
    title: 'HandTools AI - Power & Workshop Tools',
    subdomain: 'handtools.tiger-home.com',
    url: 'https://handtools.tiger-home.com/',
    description: 'Catalog handheld power tools (drills, wood routers, saws, nail guns), manual hand tools, battery ecosystems, drill/router bits, and blades.',
    category: 'Hardware & Labs',
    icon: 'wrench',
    badge: 'Workshop Tools',
    accent: 'blue',
    tags: ['Power Tools', 'Woodworking', 'Drill & Router Bits', 'Hand Tools'],
  },
  {
    id: 'consumables',
    title: 'Workshop Consumables AI - Fasteners & Stock',
    subdomain: 'consumables.tiger-home.com',
    url: 'https://consumables.tiger-home.com/',
    description: 'Inventory screws, bolts, nuts, heat-set inserts, hookup wires, 3D filaments/resins, wood/acrylic sheets, vinyl media, hobby paints, glues, and abrasives.',
    category: 'Hardware & Labs',
    icon: 'package',
    badge: 'Stock & Fasteners',
    accent: 'indigo',
    tags: ['Fasteners', '3D Filament', 'Sheet Stock', 'Paints & Glues'],
  },
  {
    id: 'pet-food',
    title: 'Dog Elimination Diet Tracker',
    subdomain: 'pet-food.tiger-home.com',
    url: 'https://pet-food.tiger-home.com/',
    description: 'Track ingredient trials, log allergy reactions, view symptom timelines, and safely identify food intolerances.',
    category: 'Pet & Health',
    icon: 'dog',
    badge: 'Diet Tracker',
    accent: 'emerald',
    tags: ['Diet Tracking', 'Dog Health', 'Allergies', 'Nutrition'],
  },
  {
    id: 'closet',
    title: 'Virtual Closet & AI Try-On',
    subdomain: 'closet.tiger-home.com',
    url: 'https://closet.tiger-home.com/',
    description: 'Digitize your wardrobe, create stylish outfit combinations, and visualize new looks with AI-powered try-on generation.',
    category: 'AI & Lifestyle',
    icon: 'shirt',
    badge: 'AI Studio',
    accent: 'purple',
    tags: ['Wardrobe', 'AI Try-On', 'Fashion Styling', 'Gemini AI'],
  },
];

export const CATEGORIES = [
  'All',
  'Hardware & Labs',
  'Pet & Health',
  'AI & Lifestyle',
] as const;
